(() => {
  const cfg = window.meeko || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const esc = s => String(s ?? "").replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

  function money(cents) {
    const fmt = cfg.money || "${{amount}}";
    const n = (cents / 100);
    const two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === "amount_no_decimals" ? Math.round(n).toLocaleString("en-AU") :
      k === "amount_with_comma_separator" ? n.toFixed(2).replace(".", ",") : two);
  }
  cfg.formatMoney = money;

  /* ---------- cart drawer ---------- */
  const drawer = $("#cartDrawer"), scrim = $("#cartScrim");
  const items = $("#drawerItems"), foot = $("#drawerFoot"), shipBar = $("#shipBar");

  function openCart() { if (!drawer) return; drawer.classList.add("on"); scrim.classList.add("on"); drawer.setAttribute("aria-hidden", "false"); $("#closeCart")?.focus(); }
  function closeCart() { if (!drawer) return; drawer.classList.remove("on"); scrim.classList.remove("on"); drawer.setAttribute("aria-hidden", "true"); }

  function setCount(n) {
    $$("[data-cart-count]").forEach(el => { el.textContent = n; el.hidden = n === 0; });
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!items) return;
    // Goals bar: free shipping, then an optional free gift at a higher spend
    const goals = [];
    if (cfg.freeShip) goals.push({ at: cfg.freeShip, short: "Free shipping", text: "free shipping" });
    if (cfg.gift2 && cfg.gift2.at) goals.push({ at: cfg.gift2.at, short: `Free ${cfg.gift2.short || cfg.gift2.name}`, text: `a free ${cfg.gift2.name}` });
    goals.sort((a, b) => a.at - b.at);
    if (shipBar && goals.length) {
      const total = cart.total_price, top = goals[goals.length - 1].at;
      const done = goals.filter(g => total >= g.at), next = goals.find(g => total < g.at);
      let msg;
      if (!next) msg = `You've unlocked ${goals.map(g => g.text).join(" + ")} ✦`;
      else if (done.length) msg = `${done.map(g => g.short).join(" + ")} unlocked ✦ ${money(next.at - total)} away from ${next.text}`;
      else msg = `You're ${money(next.at - total)} away from ${next.text}`;
      shipBar.hidden = cart.item_count === 0;
      shipBar.innerHTML = `<span>${msg}</span>
        <div class="ship-track"><i style="width:${Math.min(100, total / top * 100)}%"></i>${goals.map(g => `<b class="${total >= g.at ? "hit" : ""}" style="left:${g.at / top * 100}%"></b>`).join("")}</div>
        ${goals.length > 1 ? `<div class="ship-labels">${goals.map(g => `<span style="left:${g.at / top * 100}%">${esc(g.short)} · ${money(g.at).replace(/\.00$/, "")}</span>`).join("")}</div>` : ""}`;
    }
    if (!cart.item_count) {
      items.innerHTML = `<div class="drawer-empty"><span class="spark" style="font-size:26px">✦</span><p>Your bag is empty.</p><a class="btn btn-copper" href="${cfg.allUrl || "/collections/all"}">Shop all products</a></div>`;
      foot.innerHTML = ""; return;
    }
    // free gifts added by the gift app come through as $0 lines: show them as gifts, without quantity controls
    const isGift = it => it.final_line_price === 0 && it.original_line_price > 0;
    const giftInCart = cart.items.some(isGift);
    items.innerHTML = cart.items.map((it, i) => `
      <div class="line">
        ${it.image ? `<img src="${it.image}${it.image.includes("?") ? "&" : "?"}width=160" alt="" loading="lazy">` : `<div class="gift-thumb">✦</div>`}
        <div><a href="${it.url}"><b>${esc(it.product_title)}</b></a>
          ${it.variant_title && !/default/i.test(it.variant_title) ? `<small>${esc(it.variant_title)}</small>` : ""}
          ${isGift(it) ? `<small>✦ Free gift</small>` : `${(it.discounts || []).map(d => `<small>${esc(d.title)}</small>`).join("")}
          <span class="mini-qty"><button type="button" data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button type="button" data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="Increase">+</button></span>`}</div>
        <div class="lp">${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : ""}<span>${it.final_line_price === 0 ? "Free" : money(it.final_line_price)}</span>${isGift(it) ? "" : `<button type="button" class="rm" data-line="${i + 1}" data-qty="0">Remove</button>`}</div>
      </div>`).join("") + (cfg.giftText && !giftInCart ? `
      <div class="line"><div class="gift-thumb">✦</div><div><b>${esc(cfg.giftText)}</b><small>Free gift, added to every order</small></div><div class="lp"><span>Free</span></div></div>` : "");
    const savings = cart.total_discount ? `<div class="subtotal" style="font-size:14px;color:var(--copper-deep)"><span>You're saving</span><span>${money(cart.total_discount)}</span></div>` : "";
    foot.innerHTML = `${savings}<div class="subtotal"><span>Subtotal</span><b>${money(cart.total_price)}</b></div>
      <small>Shipping and discount codes are added at checkout.</small>
      <a class="btn btn-copper" href="/checkout">Checkout</a>
      <a class="btn btn-outline" href="${cfg.cartUrl || "/cart"}">View bag</a>`;
  }

  async function refreshCart() {
    const cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then(r => r.json());
    renderCart(cart); return cart;
  }

  // No theme drawer: hand over to the cart app by "clicking" the header cart link, which it opens as its drawer
  function openAppCart() {
    const link = $("header.site [data-open-cart]") || $("a[href$='/cart']");
    link?.click();
  }

  async function addItems(list) {
    if (!drawer) {
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: list }) });
      if (res.ok) { await refreshCart(); openAppCart(); } else { location.href = cfg.cartUrl || "/cart"; }
      return;
    }
    drawer?.classList.add("busy");
    try {
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: list }) });
      if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || "That item couldn't be added. Please try again."); }
      await refreshCart(); openCart();
      // the free gift app adds its gifts a moment later
      setTimeout(refreshCart, 1800); setTimeout(refreshCart, 4500);
    } catch (e) {
      openCart(); if (items) items.insertAdjacentHTML("afterbegin", `<p class="form-error" style="padding-top:12px">${esc(e.message)}</p>`);
    } finally { drawer?.classList.remove("busy"); }
  }

  async function changeLine(line, quantity) {
    drawer?.classList.add("busy");
    try {
      const cart = await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line, quantity }) }).then(r => r.json());
      renderCart(cart);
      setTimeout(refreshCart, 1800); setTimeout(refreshCart, 4500);
    } finally { drawer?.classList.remove("busy"); }
  }

  /* ---------- clicks ---------- */
  document.addEventListener("click", e => {
    const t = e.target.closest("[data-open-cart],[data-close-cart],[data-add],[data-line],[data-more],[data-car],[data-rev-tag],[data-menu]");
    if (!t) return;
    if (t.matches("[data-open-cart]")) { if (drawer) { e.preventDefault(); refreshCart(); openCart(); } return; }
    if (t.matches("[data-close-cart]")) { closeCart(); return; }
    if (t.matches("[data-add]")) { e.preventDefault(); addItems([{ id: +t.dataset.add, quantity: +(t.dataset.qty || 1) }]); return; }
    if (t.matches("[data-line]")) { changeLine(+t.dataset.line, Math.max(0, +t.dataset.qty)); return; }
    if (t.matches("[data-more]")) { const r = t.closest(".rev"); const open = r.classList.toggle("open"); t.textContent = open ? "Show less" : "Read more"; return; }
    if (t.matches("[data-car]")) { const c = document.getElementById(t.dataset.target); c?.scrollBy({ left: +t.dataset.car * c.clientWidth * .8, behavior: "smooth" }); return; }
    if (t.matches("[data-rev-tag]")) {
      const wrap = t.closest(".reviews"), tag = t.dataset.revTag;
      $$("[data-rev-tag]", wrap).forEach(c => c.setAttribute("aria-pressed", c === t));
      $$(".rev", wrap).forEach(r => r.hidden = tag !== "all" && !(r.dataset.tags || "").split(" ").includes(tag));
      return;
    }
    if (t.matches("[data-menu]")) { const nav = $("#siteNav"); const open = nav.classList.toggle("open"); t.setAttribute("aria-expanded", open); }
  });
  scrim?.addEventListener("click", closeCart);
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });

  /* ---------- product page ---------- */
  // Delegated listeners: cart apps (Section Store) re-render the product form, which drops listeners bound to it.
  // Our quantity input is the last "quantity" field in the form, so its value wins when the app posts the form.
  const formOf = el => el.closest("[data-product-form]") || el.closest("form");
  const qtyOf = form => $("[data-qty-input]", form) || $$("input[name='quantity']", form).pop();
  // Section Store adds its own hidden quantity field; keep every quantity field equal to ours
  const syncQtyFields = form => { const q = qtyOf(form); if (q) $$("input[name='quantity']", form).forEach(i => { if (i !== q) i.value = q.value; }); };
  ["click", "submit"].forEach(type => document.addEventListener(type, e => {
    const t = e.target.closest ? e.target.closest("[data-product-form], [data-add-btn]") : null;
    if (t) syncQtyFields(formOf(t));
  }, true));
  const syncBtn = form => {
    const btn = $("[data-add-btn]", form), qty = qtyOf(form), idInput = $("[name='id']", form);
    if (!btn || !qty || !idInput || btn.disabled) return;
    const price = +(idInput.selectedOptions?.[0]?.dataset.price || idInput.dataset.price || 0);
    const opt = $("input[name='buy_option']:checked", form);
    const total = opt && +opt.value === +qty.value ? +opt.dataset.total : price * (+qty.value || 1);
    btn.textContent = `${btn.dataset.label || "Add to cart"} · ${money(total)}`;
  };
  document.addEventListener("click", e => {
    const b = e.target.closest("[data-step-qty]"); if (!b) return;
    const form = formOf(b), qty = qtyOf(form); if (!qty) return;
    qty.value = Math.max(1, (+qty.value || 1) + +b.dataset.stepQty);
    $$("input[name='buy_option']", form).forEach(r => r.checked = +r.value === +qty.value);
    syncQtyFields(form); syncBtn(form);
  });
  document.addEventListener("change", e => {
    const t = e.target, form = t.form || formOf(t); if (!form || !form.matches("[data-product-form]")) return;
    if (t.name === "buy_option") { const qty = qtyOf(form); if (qty) qty.value = t.value; }
    syncQtyFields(form);
    if (t.name === "id" && t.selectedOptions) {
      const o = t.selectedOptions[0], btn = $("[data-add-btn]", form);
      if (btn) btn.disabled = o.dataset.available !== "true";
      $$("[data-variant-price]").forEach(el => el.textContent = money(+o.dataset.price));
    }
    syncBtn(form);
  });
  document.addEventListener("submit", e => {
    const form = e.target;
    if (!drawer || !form.matches("[data-product-form]") || e.defaultPrevented) return;
    e.preventDefault();
    addItems([{ id: +$("[name='id']", form).value, quantity: Math.max(1, +(qtyOf(form)?.value) || 1) }]);
  });
  $$("[data-product-form]").forEach(form => {
    syncBtn(form);

    // sticky add bar follows the main form
    const bar = $("#stickyBar");
    if (bar && "IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle("off", !show); bar.setAttribute("aria-hidden", !show);
      }).observe($(".add-row", form) || form);
      $("[data-sticky-add]", bar)?.addEventListener("click", () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }
  });

  // gallery
  $$("[data-gallery]").forEach(g => {
    const main = $(".gallery-main img", g);
    if (!main) return;
    $$("[data-thumb]", g).forEach(b => b.addEventListener("click", () => {
      main.src = b.dataset.src; main.srcset = b.dataset.srcset || ""; main.alt = b.dataset.alt || "";
      $$("[data-thumb]", g).forEach(x => x.setAttribute("aria-current", x === b));
    }));
  });

  // routine stepper
  $$("[data-ritual]").forEach(r => {
    let steps = [];
    try { steps = JSON.parse($("[data-ritual-json]", r).textContent); } catch (e) { return; }
    const box = $("[data-ritual-step]", r), img = $("figure img", r);
    const show = i => {
      const s = steps[i]; if (!s) return;
      box.innerHTML = `<div class="blob">${s.thumb ? `<img src="${s.thumb}" alt="" loading="lazy">` : ""}</div><p><span class="when">Step ${i + 1} · ${esc(s.when)}</span>${s.html}</p>`;
      if (img && s.image) { img.removeAttribute("srcset"); img.src = s.image; img.alt = s.title || ""; }
      $$("[data-step]", r).forEach(b => b.setAttribute("aria-pressed", +b.dataset.step === i));
    };
    $$("[data-step]", r).forEach(b => b.addEventListener("click", () => show(+b.dataset.step)));
    show(+(r.dataset.start || 0));
  });

  // Apps (Section Store, AppHero) can add to the cart themselves; follow any cart change so the drawer stays in sync
  let syncTimer, openAfter = false;
  const onCartChange = (url) => {
    if (/\/cart\/add/.test(url) && drawer) openAfter = true;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(async () => {
      await refreshCart();
      if (openAfter) { openAfter = false; openCart(); setTimeout(refreshCart, 1800); setTimeout(refreshCart, 4500); }
    }, 350);
  };
  const watched = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const p = origFetch.apply(this, arguments);
    if (watched.test(url)) p.then(r => { if (r.ok) onCartChange(url); }).catch(() => {});
    return p;
  };
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (watched.test(String(url))) this.addEventListener("load", () => { if (this.status < 400) onCartChange(String(url)); });
    return origOpen.apply(this, arguments);
  };

  if (cfg.cartCount !== undefined) setCount(cfg.cartCount);
  window.meekoCart = { open: openCart, close: closeCart, refresh: refreshCart, add: addItems };
})();
